import { render, staticRenderFns } from "./Reglements.vue?vue&type=template&id=eb0cbeee"
import script from "./Reglements.vue?vue&type=script&lang=js"
export * from "./Reglements.vue?vue&type=script&lang=js"
import style0 from "./Reglements.vue?vue&type=style&index=0&id=eb0cbeee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports